export function regexForFileExtensions(fileExtensions) {
  return (new RegExp('(.*?).(' + fileExtensions.join('|') + ')$', 'i'))
}
